export default __webpack_public_path__ + "static/media/NBA - Logo.dccfe25a.png";